<template>
    <dashboard-criticality-card
        title="Süresi Dolmak Üzere Olan İK Parametreleri"
        :fields="fields"
        :provider="provider"
        :get-level="getLevel"
        :stats-config="statsConfig"
        :enabled-levels="enabledLevels"
        excel-file-name="IK_Parametreleri" />
</template>

<script>
import HRParametersApi from "@/api/human-resources-parameters";
import DashboardCriticalityCard from "./DashboardCriticalityCard.vue";

export default {
    components: { DashboardCriticalityCard },
    props: {
        enabledLevels: { type: Array, default: null },
    },
    data() {
        return {
            fields: [
                { name: "Parametre", key: "VisibleName", thClass: "w-50" },
                { name: "Kalan Gün", key: "DaysRemaining" },
            ],
            statsConfig: [
                { key: "danger", label: "Kritik (≤7 gün)", variant: "danger" },
                { key: "warning", label: "Yaklaşan (≤30 gün)", variant: "warning" },
                { key: "secondary", label: "Takipte", variant: "secondary" },
            ],
        };
    },
    methods: {
        provider() {
            return HRParametersApi.ParametersToExpire();
        },
        getLevel(r) {
            const d = Number(r?.DaysRemaining);
            if (Number.isFinite(d)) {
                if (d <= 7) return "danger";
                if (d <= 30) return "warning";
                return "secondary";
            }
            return "danger";
        },
    },
};
</script>
